<div class="box box-info">
  <div class="box-header with-border">
    <h3 class="box-title">
      Change password
      @if (user) {
        <p style="display: inline;">
          : {{ user.first_name }} {{ user.last_name }} ({{ user.email }})
        </p>
      }
    </h3>
  </div>
  <!-- /.box-header -->
  <!-- form start -->
  <form class="form-horizontal" role="form" [formGroup]="form" novalidate>
    <div class="box-body">
      <div class="form-group">
        <label for="inputPassword3" class="col-sm-3 control-label"
          >New password</label
          >

          <div class="col-sm-9">
            <input
              type="text"
              class="form-control"
              formControlName="new_password"
              />
            @if (
              form.controls['new_password'].hasError('required') &&
              (form.controls['new_password'].touched || attemptedSubmit)
              ) {
              <control-message
                message="Password is required."
              ></control-message>
            }
            @if (
              form.controls['new_password'].hasError('minlength') &&
              (form.controls['new_password'].touched || attemptedSubmit)
              ) {
              <control-message
                message="Password is too short."
              ></control-message>
            }
          </div>
        </div>
      </div>
      <!-- /.box-body -->
      <div class="box-footer">
        <div class="box-footer">
          @if (randomPassword == null && showGeneratePassword) {
            <button
              type="button"
              class="btn btn-info pull-left"
              (click)="generatePassword()"
              >
              Generate password
            </button>
          }

          @if (randomPassword != null && showGeneratePassword) {
            <button
              type="button"
              class="btn btn-info pull-left"
              ngxClipboard
              [cbContent]="form.controls['new_password'].value"
              (cbOnSuccess)="copiedSuccess()"
              >
              Copy
            </button>
          }

          <button
            type="button"
            (click)="submitForm()"
            class="btn btn-info pull-right"
            >
            Change password
          </button>
        </div>
      </div>
      <!-- /.box-footer -->
    </form>
  </div>
